module.exports = __webpack_public_path__ + "img/moon-cloud.f75e4211.svg";